import {
  Component,
  Input,
  Output,
  EventEmitter,
  CUSTOM_ELEMENTS_SCHEMA,
} from '@angular/core';

import { NavigationExtras, Router, RouterModule } from '@angular/router';

import '@cigna/leaf-web/lib/wc/components/danger-button/danger-button';

import type { LeafDangerButton } from '@cigna/leaf-web/lib/wc';

@Component({
  selector: 'cigna-leaf-danger-button',
  standalone: true,
  imports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <leaf-danger-button
      [text]="text"
      [loading]="loading"
      [ariaLive]="ariaLive"
      [buttonAriaExpanded]="buttonAriaExpanded"
      [disabled]="disabled"
      [fullWidth]="fullWidth"
      [hideText]="hideText"
      [href]="href"
      [iconRotateDegree]="iconRotateDegree"
      [iconFlipDirection]="iconFlipDirection"
      [iconPosition]="iconPosition"
      [inverted]="inverted"
      [loadingComplete]="loadingComplete"
      [rel]="rel"
      [size]="size"
      [svg]="svg"
      [target]="target"
      [variant]="variant"
      [type]="type"
      [value]="value"
      (click)="handleClick($event)"
    >
    </leaf-danger-button>
  `,
})
export class CignaLeafDangerButtonComponent {
  @Input() text: LeafDangerButton['text'];
  @Input() loading: LeafDangerButton['loading'];
  @Input() ariaLive: LeafDangerButton['ariaLive'];
  @Input() buttonAriaExpanded: LeafDangerButton['buttonAriaExpanded'];
  @Input() disabled: LeafDangerButton['disabled'];
  @Input() fullWidth: LeafDangerButton['fullWidth'];
  @Input() hideText: LeafDangerButton['hideText'];
  @Input() href: LeafDangerButton['href'];
  @Input() iconRotateDegree: LeafDangerButton['iconRotateDegree'];
  @Input() iconFlipDirection: LeafDangerButton['iconFlipDirection'];
  @Input() iconPosition: LeafDangerButton['iconPosition'];
  @Input() inverted: LeafDangerButton['inverted'];
  @Input() loadingComplete: LeafDangerButton['loadingComplete'];
  @Input() rel: LeafDangerButton['rel'];
  @Input() size: LeafDangerButton['size'];
  @Input() svg: LeafDangerButton['svg'];
  @Input() target: LeafDangerButton['target'];
  @Input() variant: LeafDangerButton['variant'];
  @Input() type: LeafDangerButton['type'];
  @Input() value: LeafDangerButton['value'];
  /**
   * ********
   * CUSTOM ANGULAR PROPERTIES
   */
  @Input() routerLink?: boolean;
  @Input() navigationExtras?: NavigationExtras;

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onClick = new EventEmitter<MouseEvent>();

  constructor(private router: Router) {}

  handleClick(event: MouseEvent) {
    if (this.routerLink && this.href) {
      event.preventDefault();
      event.stopPropagation();
      this.router.navigateByUrl(this.href, this.navigationExtras);
    } else {
      this.onClick.emit(event);
    }
  }
}
